// extracted by mini-css-extract-plugin
export default {"container":"MiniCardUser_container__sLa4U"};